import { render, staticRenderFns } from "./WalletRecharge.vue?vue&type=template&id=a8fcda0a&scoped=true&"
import script from "./WalletRecharge.vue?vue&type=script&lang=js&"
export * from "./WalletRecharge.vue?vue&type=script&lang=js&"
import style0 from "./WalletRecharge.vue?vue&type=style&index=0&id=a8fcda0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fcda0a",
  null
  
)

export default component.exports